<template>
  <Contact_index/>
  <Contact_page/>
  <Footer/>

</template>
<script>
import Contact_index from '../../components/CN/contact/Contact_index'
import Contact_page from "@/components/CN/contact/Contact_page";
import Footer from "@/components/CN/Footer";
import Header from '../../components/CN/Header'

export default {
  name: 'Contact',
  components: {
    Footer,
    Contact_index,
    Contact_page,
    Header,
  }
}
</script>
<style scoped>

</style>

